export const PageHeader = ({ title, subtitle, icon: Icon, actions, children }) => (
  <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
    <div className="flex items-start gap-3">
      {Icon && (
        <div className="mt-0.5 flex h-11 w-11 items-center justify-center rounded-2xl accent-bg-100">
          <Icon className="h-5 w-5 accent-text" />
        </div>
      )}
      <div>
        <h1 className="font-display text-2xl font-semibold tracking-tight text-foreground sm:text-3xl">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
      </div>
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
    {children}
  </div>
);
